import { render, staticRenderFns } from "./EmailDrawer.vue?vue&type=template&id=3b30554b&scoped=true&"
import script from "./EmailDrawer.vue?vue&type=script&lang=js&"
export * from "./EmailDrawer.vue?vue&type=script&lang=js&"
import style0 from "./EmailDrawer.vue?vue&type=style&index=0&id=3b30554b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b30554b",
  null
  
)

export default component.exports